import script from "./Back.vue?vue&type=script&setup=true&lang=js"
export * from "./Back.vue?vue&type=script&setup=true&lang=js"

import "./Back.vue?vue&type=style&index=0&id=4c25bffa&lang=css"

const __exports__ = script;

export default __exports__